<template>
    <svg class="x-navbar-menu-icon" width="17" height="17" viewBox="0 0 24 24"
         fill="none" stroke="currentColor" stroke-width="1.5"
         stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
        <g v-html="paths"></g>
    </svg>
</template>
<script>
// Static SVG paths shared with the CRM layout reference.
const icons = {
    "flag": "<path d=\"M3 4h18l-7 8v6l-4 2v-8L3 4Z\"></path>",
    "inbox": "<path d=\"M22 12h-6l-2 3h-4l-2-3H2\"></path><path d=\"M5.5 5h13l3.5 7v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-5l3.5-7Z\"></path>",
    "usersGroup": "<path d=\"M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2\"></path><circle cx=\"9\" cy=\"7\" r=\"4\"></circle><path d=\"M22 21v-2a4 4 0 0 0-3-3.87\"></path>",
    "usersPair": "<path d=\"M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2\"></path><circle cx=\"12\" cy=\"7\" r=\"4\"></circle>",
    "owners": "<path d=\"M3 21h18M5 21V7l8-4v18M19 21V11l-6-4\"></path><path d=\"M9 9h.01M9 13h.01\"></path>",
    "plus": "<path d=\"M12 5v14M5 12h14\"></path>",
    "search": "<circle cx=\"11\" cy=\"11\" r=\"7\"></circle><path d=\"m21 21-4.3-4.3\"></path>",
    "draft": "<path d=\"M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z\"></path><path d=\"M14 2v6h6\"></path>",
    "incorporadoras": "<path d=\"M3 21h18M5 21V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v16M15 21V9h2a2 2 0 0 1 2 2v10\"></path>",
    "construtoras": "<path d=\"M10 20v-4h4v4M3 10l9-7 9 7M5 9v11h14V9\"></path>",
    "administradoras": "<rect x=\"3\" y=\"4\" width=\"18\" height=\"16\" rx=\"2\"></rect><path d=\"M3 10h18M8 4v16\"></path>",
    "reportAnalytics": "<path d=\"M3 3v18h18\"></path><path d=\"m7 14 3-3 3 3 4-5\"></path>",
    "reportPerformance": "<path d=\"M3 3v18h18\"></path><rect x=\"7\" y=\"10\" width=\"3\" height=\"7\"></rect><rect x=\"13\" y=\"6\" width=\"3\" height=\"11\"></rect>",
    "grid4": "<rect x=\"3\" y=\"3\" width=\"7\" height=\"7\" rx=\"1.5\"></rect><rect x=\"14\" y=\"3\" width=\"7\" height=\"7\" rx=\"1.5\"></rect><rect x=\"3\" y=\"14\" width=\"7\" height=\"7\" rx=\"1.5\"></rect><rect x=\"14\" y=\"14\" width=\"7\" height=\"7\" rx=\"1.5\"></rect>",
    "aiUpdate": "<path d=\"M3 12a9 9 0 1 0 9-9\"></path><path d=\"M3 3v6h6\"></path><path d=\"m9 13 2 2 4-4\"></path>",
    "faq": "<circle cx=\"12\" cy=\"12\" r=\"9\"></circle><path d=\"M9.5 9a2.5 2.5 0 1 1 3.4 2.3c-.6.3-.9.8-.9 1.4v.3\"></path><path d=\"M12 17h.01\"></path>",
    "academy": "<path d=\"M22 10 12 5 2 10l10 5 10-5Z\"></path><path d=\"M6 12v5c3 2 9 2 12 0v-5\"></path>",
    "invoice": "<rect x=\"2\" y=\"5\" width=\"20\" height=\"14\" rx=\"2\"></rect><path d=\"M2 10h20M6 15h4\"></path>",
    "calendar": "<rect x=\"3\" y=\"5\" width=\"18\" height=\"16\" rx=\"2\"></rect><path d=\"M16 3v4M8 3v4M3 11h18\"></path>",
    "approval": "<path d=\"m9 12 2 2 4-4\"></path><path d=\"M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z\"></path>"
}

export default {
    props: { name: { type: String, required: true } },
    computed: {
        paths () { return icons[this.name] || '' }
    }
}
</script>



// WEBPACK FOOTER //
// NavbarMenuIcon.vue?6577f19e